import type { Definition, Step } from "../types";

/** Why the settings would keep a workflow from running for the sample facts (backend `Mismatch`). */
export const MISMATCH_KEYS = ["agent", "channel", "schedule", "conditions"] as const;
export type Mismatch = (typeof MISMATCH_KEYS)[number];

export function isMismatch(value: string | null): value is Mismatch {
  return MISMATCH_KEYS.some((key) => key === value);
}

/**
 * Every step of a definition by the id a dry run reports: top-level steps by their own id, the
 * actions inside an Apply rules step as `<step id>.<action id>`.
 */
export function stepsById(definition: Definition): Map<string, Step> {
  const found = new Map<string, Step>();
  for (const path of Object.values(definition.paths)) {
    for (const step of path.steps) {
      found.set(step.id, step);
      if (step.type !== "apply_rules") continue;
      for (const rule of step.rules) {
        for (const action of rule.actions) found.set(`${step.id}.${action.id}`, action);
      }
    }
  }
  return found;
}

/** Planned steps grouped by the path they belong to, in the order the walk took them. */
export function groupByPath<T extends { path: string }>(steps: readonly T[]): { path: string; steps: T[] }[] {
  const groups: { path: string; steps: T[] }[] = [];
  for (const step of steps) {
    const last = groups.at(-1);
    if (last?.path === step.path) last.steps.push(step);
    else groups.push({ path: step.path, steps: [step] });
  }
  return groups;
}
